/* eslint-disable no-return-await,no-magic-numbers */

import {
  AddressMasterRequestParams,
  addressMasterV1Client,
  AreaData,
  CityData,
  HoodData,
  Response,
  TopAreaData,
} from '@y2/api-clients/address-master-v1';
import { CLIENT_QUERY_KEYS } from '../../services/params/consts';

const { TOP_AREA, AREA, CITY, HOOD } = CLIENT_QUERY_KEYS;

const addressClient = addressMasterV1Client();

export type GenericAddressData = TopAreaData | AreaData | CityData | HoodData;

type GenericAddressResponse = {
  data: Response<GenericAddressData>;
};

export const isTopArea = (
  address: GenericAddressData,
): address is TopAreaData => address?.type_weight === 650;
export const isArea = (address: GenericAddressData): address is AreaData =>
  address?.type_weight === 550;
export const isCity = (address: GenericAddressData): address is CityData =>
  address?.type_weight === 450;
export const isHood = (address: GenericAddressData): address is HoodData =>
  address?.type_weight === 350;

export const getAddressMaster = async ({
  [TOP_AREA]: topArea,
  [AREA]: area,
  [CITY]: city,
  [HOOD]: neighborhood,
}: AddressMasterRequestParams): Promise<GenericAddressResponse> => {
  if (neighborhood) {
    return await addressClient.getHood(neighborhood);
  }
  if (city) {
    return await addressClient.getCity(city);
  }
  if (area) {
    return await addressClient.getArea(area);
  }
  if (topArea) {
    return await addressClient.getTopArea(topArea);
  }
  return { data: { data: { data: [] } } } as GenericAddressResponse;
};
